import { PaymentLedger } from "@/shared/utils/interfaces";
import usePaymentLedgerHook from "@/shared/hooks/usePaymentLedgerHook";
import useSplitPaymentHook from "@/shared/hooks/useSplitPaymentHook";
import SplitPaymentLedgerPayments from "./SplitPaymentLedgerPayments";
import SplitPaymentLedgerEmail from "./SplitPaymentLedgerEmail";
import SplitPaymentLedgerInputs from "./SplitPaymentLedgerInputs";
import SplitPaymentLedgerAction from "./SplitPaymentLedgerAction";
import SplitPaymentLedgerHeader from "./SplitPaymentLedgerHeader";
import usePaymentHook from "@/shared/hooks/usePaymentHook";
import { useState } from "react";

let ledgerInProcess: number | null = null;
type Props = {
  ledger: PaymentLedger;
  index: number;
  splitPaymentCart: any[];
};

const SplitPaymentLedger = ({ ledger, index, splitPaymentCart }: Props) => {
  const {
    updateLedger,
    isPending,
    handlePayment,
    printLedger,
    deleteLedger,
    handlePaymentWithCashDro,
  } = useSplitPaymentHook(splitPaymentCart);
  const { data: ledgers, isFetching } = usePaymentLedgerHook();
  const defaultLedger = ledgers?.find((l) => l.item_id === ledger.item_id);
  const { isOnlinePayment } = usePaymentHook();
  const isDefaultPaidOnline =
    isOnlinePayment(defaultLedger?.payment_method_id) && defaultLedger?.is_paid;
  const [isCashDroSelected, setIsCashDroSelected] = useState(false);

  return (
    <div className={"h-auto border border-border rounded-2xl w-full "}>
      <SplitPaymentLedgerHeader
        index={index}
        defaultLedger={defaultLedger}
        ledger={ledger}
        isFetching={ledgerInProcess === index && (isPending || isFetching)}
      />
      <div className="flex flex-col gap-4 mt-2 px-6 py-2">
        <SplitPaymentLedgerInputs ledger={ledger} updateLedger={updateLedger} />
        <SplitPaymentLedgerPayments
          paymentId={ledger.payment_method_id}
          setPaymentId={(paymentId, isCashDroSelected) => {
            updateLedger(ledger.item_id, { payment_method_id: paymentId });
            setIsCashDroSelected(isCashDroSelected);
          }}
          isDisabled={isDefaultPaidOnline}
          isCashDroSelected={isCashDroSelected}
        />
        <SplitPaymentLedgerEmail
          isOnline={isOnlinePayment(ledger.payment_method_id)}
          ledger={ledger}
          updateLedger={updateLedger}
        />
        <SplitPaymentLedgerAction
          onClickPayment={() => {
            ledgerInProcess = index;
            isCashDroSelected
              ? handlePaymentWithCashDro(ledger)
              : handlePayment(ledger);
          }}
          ledger={ledger}
          defaultLedger={defaultLedger}
          isFetching={ledgerInProcess === index && (isPending || isFetching)}
          onClickDelete={() => deleteLedger(ledger)}
          onClickPrint={() => printLedger(ledger)}
        />
      </div>
    </div>
  );
};

export default SplitPaymentLedger;
